class lookupData {
    constructor(
        id,
        name,
        description) {
        this.id = id;
        this.name = name;
        this.description = description;
    }
    static fromJson({
        id,
        nombre,
        detalle
    }) {
        return new lookupData(
            id,
            nombre,
            detalle
        );
    }
}
export default lookupData;
